<template>
        <div class="d-flex align-items-center mb-4 w-100" >
            <div style="width: 150px; height: 150px;" class="loading-skeleton rounded-circle">
            </div>
            <div class="ms-2">
                <h3 class="fw-bold loading-skeleton">Booking Title </h3>
                <p class="text-muted py-2 loading-skeleton"></p>
            </div>
        </div>
</template>